import { Button, ButtonProps, Tooltip } from 'antd';
import { MouseEventHandler, ReactNode } from 'react';

export interface IconButtonProps {
  title: string;
  icon: ReactNode;
  onClick: (event: MouseEventHandler<HTMLElement> | any) => void;
  buttonProps?: ButtonProps;
}

function IconButton({ title, icon, onClick, buttonProps }: IconButtonProps) {
  return (
    <Tooltip title={title} placement="bottomLeft">
      <Button
        type="primary"
        shape="circle"
        size="small"
        icon={icon}
        onClick={onClick}
        {...(buttonProps || {})}
      />
    </Tooltip>
  );
}

export default IconButton;
